import { usePolicyAcknowledgement } from "@/hooks/usePolicyAcknowledgement";
import { PolicyAcknowledgementDialog } from "./PolicyAcknowledgementDialog";

/**
 * Auto-opening wrapper for PolicyAcknowledgementDialog
 * Shows the dialog automatically when user has pending policies to acknowledge
 */
export const PolicyAcknowledgementDialogAuto = () => {
  const {
    pendingPolicies,
    needsAcknowledgement,
    acknowledgePolicies,
    isAcknowledging,
  } = usePolicyAcknowledgement();

  if (!needsAcknowledgement) return null;

  return (
    <PolicyAcknowledgementDialog
      open={needsAcknowledgement}
      // @ts-ignore - Type mismatch will resolve when Supabase types regenerate
      policies={pendingPolicies}
      onAcknowledge={acknowledgePolicies}
      isAcknowledging={isAcknowledging}
    />
  );
};
